import type { ShopDto, UpdateShopExchangeDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdatePortalExchange(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);
  return useApiMutation("patch", "/shops/{shopId}/exchanges", {
    invalidate: invalidateShop,
    mapVariables: (data: UpdateShopExchangeDto) => ({
      params: { path: { shopId: shop.id } },
      body: data,
    }),
  });
}
